import {useEffect} from 'react'
import {useHistory, useLocation} from 'react-router-dom';
import {clearAuth, loadAuth} from "../../libraries/Authentication";

export default ({children, user, setUser, setJwtToken, loadingUser}) => {
    const location = useLocation()
    const history = useHistory()

    const {isLoaded, isLoading, currentUser} = user

    useEffect(() => {
        if (!isLoaded && !isLoading) {
            loadingUser()
            const auth = loadAuth()
            if (auth && auth.token && auth.user) {
                setJwtToken(auth.token)
                setUser(auth.user, auth.user.referenceId)
            } else {
                clearAuth()
                if (!location.pathname.includes('login') && !(location.pathname.includes('register'))) {
                    history.push('/login')
                }
                setUser(null, null)
            }
        }

        if (isLoaded && !currentUser) {
            if (!location.pathname.includes('login') && !(location.pathname.includes('register'))) {
                history.push('/login')
            }
        } else if (isLoaded) {
            if (location.pathname.includes('login') || (location.pathname.includes('register'))) {
                history.push('/')
            }
        }

    }, [isLoaded, isLoading])

    return (
        children
    )
}
